import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  NgZone,
  Renderer2,
  effect,
  inject,
  input,
  output,
} from '@angular/core';

@Component({
  selector: 'qaroni-animation',
  templateUrl: './qaroni-animation.component.html',
  styleUrls: ['./qaroni-animation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class QaroniAnimationComponent {
  readonly loop = input<boolean>(true);
  readonly autoplay = input<boolean>(true);
  readonly src = input<string>('');
  readonly width = input<number>(0);
  readonly height = input<number>(0);

  readonly animationCreated = output<unknown>();

  private readonly _el = inject(ElementRef);
  private readonly _renderer = inject(Renderer2);
  private readonly _zone = inject(NgZone);

  constructor() {
    effect(() => {
      this.loop();
      this.autoplay();
      this.src();
      this.width();
      this.height();

      this._zone.runOutsideAngular(() => this.loadResource());
    });
  }

  async loadResource() {
    const defaultOptions = {
      container: this._el.nativeElement,
      renderer: 'svg',
      loop: this.loop(),
      autoplay: this.autoplay(),
      path: this.src(),
    };

    this._el.nativeElement.innerHTML = '';

    const { default: bodymovin } =
      await import('lottie-web/build/player/lottie.min');
    const anim = bodymovin.loadAnimation(defaultOptions);

    this.animationCreated.emit(anim);

    const width = this.width();
    if (width) {
      this._renderer.setStyle(this._el.nativeElement, 'width', `${width}px`);
    }

    const height = this.height();
    if (height) {
      this._renderer.setStyle(this._el.nativeElement, 'height', `${height}px`);
    }
  }
}
